export enum PersistentStorageKeys {
    'ctQ-grid',
    'functionDataReviews-grid',
    'ctq-risk-child-grid',
    'ctq-fdr-child-grid',
    'risk-log-risk-grid',
    'risk-log-evaluations',
    'risk-log-ctqs',
    'risk-log-controls',
    'risk-log-monitoring-observations',
    'risk-log-monitoring-actions',
    'risk-monitoring-actions',
    'risk-monitoring-child-actions',
    'risk-monitoring-manage-obs',
    'manage_risk-reviews-risks',
    'manage_risk-reviews-attendees',
    'risk-log-cm-controls',
    'cm-controls-control-hub-chart',
    'cm-controls-risk-grid',
    'cm-controls-popout-top-grid',
    'cm-controls-popout-risks-child',
    'cm-controls-popout-controls-observations',
    'cm-controls-popout-review-logs',
    'cm-controls-popout-controls-actions',
}
